// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "_" + "1dbd88bf6f249e9b7164" + ".js";
};